import { Component, OnInit } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { ExportacaoLeadService } from 'src/app/services/exportacao-lead.service';

@Component({
    selector: 'app-lista-exportacao-lead',
    templateUrl: './lista-exportacao-lead.component.html',
    styleUrls: ['./lista-exportacao-lead.component.css'],
    standalone: false
})
export class ListaExportacaoLeadComponent implements OnInit {
  pageSize = 10;
  pageIndex = 1;
  total = 0;
  loading = false;
  exportacoes = [];
  
  //pesquisa
  pesquisaDataInicial = '';
  pesquisaDataFinal = '';
  constructor(
    private exportacaoLeadService: ExportacaoLeadService,
    private message: NzMessageService,
  ) { }

  ngOnInit(): void {
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    this.loading = true;
    this.exportacaoLeadService.all(params.pageIndex).subscribe((c:any)=>{

      this.exportacoes = c.data.exportacoes.data;
      this.total = c.data.exportacoes.total;
      this.pageSize = c.data.exportacoes.per_page;
      this.loading = false;
    });
  }

  recarregarDados(){
    this.loading = true;
    this.exportacaoLeadService.all(this.pageIndex).subscribe((c:any)=>{
      this.exportacoes = c.data.exportacoes.data;
      this.total = c.data.exportacoes.total;
      this.pageSize = c.data.exportacoes.per_page;
      this.loading = false;
    });
  }

  pesquisar(){
    var tpInicial = new Date(this.pesquisaDataInicial);
    var tpFinal = new Date(this.pesquisaDataFinal);

    if(tpInicial <= tpFinal){
      this.loading = true;
      this.exportacaoLeadService.all(1, '', 10, this.pesquisaDataInicial, this.pesquisaDataFinal).subscribe((c:any)=>{
        this.exportacoes = c.data.exportacoes.data;
        this.total = c.data.exportacoes.total;
        this.pageSize = c.data.exportacoes.per_page;
        this.pageIndex = 1;
        this.loading = false;
      });
    }else{
      this.message.error('A data inicial é maior que a data final, a pesquisa não foi realizada.');
    }
    
  }

  cancelarPesquisa(){
    this.recarregarDados();
    this.pesquisaDataFinal = '';
    this.pesquisaDataInicial = '';
  }

  download(id: any, name: any = ''){
    this.loading = true;
    let loading = this.message.loading('Processando...').messageId;
    this.exportacaoLeadService.download(id).subscribe((data: any) => {
      this.loading = false;
      this.message.remove(loading);
      this.message.success('O seu download irá começar em instantes...');
      var downloadURL = window.URL.createObjectURL(data);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = name ?? "exportacao_leads.csv";
      link.click();
    }, () => {
      this.loading = false;
      this.message.error('Houve uma falha ao realizar o download da exportação, tente novamente mais tarde!');
    });
  }

}
